/**
 * CLNF mobile bottom nav + Shop Now sheet.
 * Hardcoded from ConvertCart experiment 90034942 (vanilla JS, no jQuery).
 */
(function () {
  'use strict';

  if (window.__clnfBottomNavBound) return;
  window.__clnfBottomNavBound = true;

  var ARROW_SRC = '';

  var FOCUSABLE_SELECTOR =
    'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]),' +
    ' select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  var triggerEl = null;
  var lastCategoryLink = null;

  var SUB_LINKS = {
    'bulk-foods': {
      label: 'Bulk Foods',
      href: '/collections/bulk-foods',
      items: [
        { label: 'Beans', href: '/collections/beans' },
        { label: 'Lentils', href: '/collections/lentils' },
        { label: 'Flours & Mixes', href: '/collections/flour' },
        { label: 'Grains & Rice', href: '/collections/grains' },
        { label: 'Oats', href: '/collections/flaked-grains' }
      ]
    },
    'fruits-1': {
      label: 'Fruits',
      href: '/collections/fruits-1',
      items: [
        { label: 'Dried Fruit', href: '/collections/dried-fruit' },
        { label: 'Juice', href: '/collections/juice' }
      ]
    },
    'healthy-beauty': {
      label: 'Health & Beauty',
      href: '/collections/healthy-beauty',
      items: [
        { label: 'Supplements', href: '/collections/supplements' },
        { label: 'Personal Care', href: '/collections/healthy-beauty' }
      ]
    },
    nuts: {
      label: 'Nuts & Seeds',
      href: '/collections/nuts',
      items: [
        { label: 'Nuts', href: '/collections/nuts' },
        { label: 'Seeds', href: '/collections/seeds' },
        { label: 'Nut & Seed Butters', href: '/collections/nut-seed-butters' },
        { label: 'Trail Mix', href: '/collections/nut-mixes' }
      ]
    },
    snacks: {
      label: 'Snacks & Sweets',
      href: '/collections/fruits',
      items: [
        { label: 'Carob & Sweets', href: '/collections/carob-candy' },
        { label: 'Honey', href: '/collections/honey' },
        { label: 'Jams', href: '/collections/jams' },
        { label: 'Sweeteners', href: '/collections/other-sweetners' },
        { label: 'Savory Snacks', href: '/collections/crackers-snacks' },
        { label: 'Meat Alternatives', href: '/pages/search?q=meat' }
      ]
    },
    kitchenware: {
      label: 'Kitchenware',
      href: '/collections/kitchenware',
      items: [
        { label: 'Grain Mills', href: '/pages/search?q=nutrimil' },
        { label: 'Kitchen Knives', href: '/collections/kitchen-knives' },
        { label: 'Cutting Boards', href: '/collections/cutting-boards' },
        { label: 'The Sprout Spout', href: '/products/the-sprout-spout-old-listing' }
      ]
    }
  };

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }

  function qsa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function setInert(el, on) {
    if (!el) return;
    if (on) {
      el.setAttribute('inert', '');
    } else {
      el.removeAttribute('inert');
    }
  }

  function focusEl(el) {
    if (!el || typeof el.focus !== 'function') return;
    try {
      el.focus({ preventScroll: true });
    } catch (err) {
      el.focus();
    }
  }

  function isOpen(sheet) {
    return !!sheet && sheet.classList.contains('cc-sheet-open');
  }

  function isSubOpen(slider) {
    return !!slider && slider.classList.contains('cc-show-sub');
  }

  function focusablesInPanel(sheet, slider) {
    var items = [];
    var closeBtn = qs('.cc-shop-panel-close', sheet);
    if (closeBtn) items.push(closeBtn);
    var pane = qs(isSubOpen(slider) ? '.cc-pane-sub' : '.cc-pane-main', sheet);
    if (pane) items = items.concat(qsa(FOCUSABLE_SELECTOR, pane));
    return items;
  }

  function showMainPane(sheet, slider, moveFocus) {
    if (slider) slider.classList.remove('cc-show-sub');
    setInert(qs('.cc-pane-sub', sheet), true);
    setInert(qs('.cc-pane-main', sheet), false);
    if (moveFocus) {
      focusEl(lastCategoryLink || qs('.cc-shop-panel-close', sheet));
    }
    lastCategoryLink = null;
  }

  function removeConvertCartDuplicates() {
    qsa('.cc-bottom-nav-90034942:not([data-clnf-bottom-nav])').forEach(function (el) {
      el.parentNode && el.parentNode.removeChild(el);
    });
    qsa('.cc-shop-overlay:not([data-clnf-bottom-nav])').forEach(function (el) {
      el.parentNode && el.parentNode.removeChild(el);
    });
    qsa('.cc-shop-panel:not([data-clnf-bottom-nav])').forEach(function (el) {
      el.parentNode && el.parentNode.removeChild(el);
    });
  }

  function openSheet(overlay, sheet, slider) {
    setInert(sheet, false);
    sheet.classList.add('cc-sheet-open');
    overlay.classList.add('cc-sheet-open');
    document.body.classList.add('cc-sheet-open-90034942');
    if (triggerEl) triggerEl.setAttribute('aria-expanded', 'true');
    focusEl(focusablesInPanel(sheet, slider)[0]);
  }

  function closeSheet(overlay, sheet) {
    sheet.classList.remove('cc-sheet-open');
    overlay.classList.remove('cc-sheet-open');
    document.body.classList.remove('cc-sheet-open-90034942');
    setInert(sheet, true);
    if (triggerEl) triggerEl.setAttribute('aria-expanded', 'false');
  }

  function closeAll(overlay, sheet, slider, restoreFocus) {
    closeSheet(overlay, sheet);
    showMainPane(sheet, slider, false);
    if (restoreFocus) focusEl(triggerEl);
  }

  function openSubPanel(slug, sheet, slider) {
    var data = SUB_LINKS[slug];
    if (!data) return;
    if (!data.items.length) {
      window.location.href = data.href;
      return;
    }

    var title = qs('.cc-sub-panel-title', sheet);
    var list = qs('.cc-sub-panel-list', sheet);
    if (!title || !list) return;

    title.textContent = data.label;
    list.textContent = '';

    var viewAllLi = document.createElement('li');
    var viewAll = document.createElement('a');
    viewAll.className = 'cc-sub-view-all';
    viewAll.href = data.href;
    var viewAllText = document.createElement('span');
    viewAllText.textContent = 'View All ' + data.label;
    viewAll.appendChild(viewAllText);
    if (ARROW_SRC) {
      var viewAllArrow = document.createElement('span');
      viewAllArrow.className = 'cc-sub-link-arrow';
      var viewAllImg = document.createElement('img');
      viewAllImg.src = ARROW_SRC;
      viewAllImg.alt = 'arrow';
      viewAllArrow.appendChild(viewAllImg);
      viewAll.appendChild(viewAllArrow);
    }
    viewAllLi.appendChild(viewAll);
    list.appendChild(viewAllLi);

    data.items.forEach(function (item) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.className = 'cc-sub-panel-link';
      a.href = item.href;
      var label = document.createElement('span');
      label.textContent = item.label;
      a.appendChild(label);
      if (ARROW_SRC) {
        var arrow = document.createElement('span');
        arrow.className = 'cc-sub-link-arrow';
        var img = document.createElement('img');
        img.src = ARROW_SRC;
        img.alt = 'arrow';
        arrow.appendChild(img);
        a.appendChild(arrow);
      }
      li.appendChild(a);
      list.appendChild(li);
    });

    if (slider) slider.classList.add('cc-show-sub');
    setInert(qs('.cc-pane-main', sheet), true);
    setInert(qs('.cc-pane-sub', sheet), false);
    focusEl(qs('.cc-sub-back-btn', sheet));
  }

  function init() {
    removeConvertCartDuplicates();

    var nav = qs('.cc-bottom-nav-90034942[data-clnf-bottom-nav]');
    var overlay = qs('.cc-shop-overlay[data-clnf-bottom-nav]');
    var sheet = qs('.cc-shop-panel[data-clnf-bottom-nav]');
    var slider = qs('.cc-panel-slider', sheet);
    if (!nav || !overlay || !sheet) return;

    ARROW_SRC = sheet.getAttribute('data-arrow-src') || '';
    document.body.classList.add('cc-stickyNav90034942');

    setInert(sheet, true);
    setInert(qs('.cc-pane-sub', sheet), true);
    setInert(qs('.cc-pane-main', sheet), false);

    triggerEl = qs('.cc-shop-trigger', nav);
    if (triggerEl) {
      triggerEl.setAttribute('aria-expanded', 'false');
      triggerEl.addEventListener('click', function (e) {
        e.preventDefault();
        openSheet(overlay, sheet, slider);
      });
    }

    overlay.addEventListener('click', function () {
      closeAll(overlay, sheet, slider, true);
    });

    var closeBtn = qs('.cc-shop-panel-close', sheet);
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        closeAll(overlay, sheet, slider, true);
      });
    }

    document.addEventListener(
      'click',
      function (e) {
        var link = e.target.closest && e.target.closest('.cc-shop-panel-link');
        if (!link || !sheet.contains(link)) return;
        e.preventDefault();
        e.stopPropagation();
        var slug = link.getAttribute('data-collection');
        if (!slug) return;
        lastCategoryLink = link;
        openSubPanel(slug, sheet, slider);
      },
      true
    );

    var subHeader = qs('.cc-sub-panel-header', sheet);
    if (subHeader) {
      subHeader.addEventListener('click', function () {
        showMainPane(sheet, slider, true);
      });
    }

    sheet.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' && e.keyCode !== 9) return;
      if (!isOpen(sheet)) return;
      var items = focusablesInPanel(sheet, slider);
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (e.shiftKey) {
        if (document.activeElement === first) {
          e.preventDefault();
          focusEl(last);
        }
      } else if (document.activeElement === last) {
        e.preventDefault();
        focusEl(first);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' && e.key !== 'Esc' && e.keyCode !== 27) return;
      if (!isOpen(sheet)) return;
      if (isSubOpen(slider)) {
        showMainPane(sheet, slider, true);
        return;
      }
      closeAll(overlay, sheet, slider, true);
    });

    qsa('.cc-nav-item:not([data-nav="shop"]) a', nav).forEach(function (a) {
      a.addEventListener('click', function () {
        closeAll(overlay, sheet, slider, false);
      });
    });

    if (typeof MutationObserver === 'function') {
      var observer = new MutationObserver(function () {
        removeConvertCartDuplicates();
      });
      observer.observe(document.body, { childList: true, subtree: false });
      setTimeout(function () {
        observer.disconnect();
      }, 15000);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
